(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bupba-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const findSection = (element) => element.closest('.bupba-product');

    const showMedia = (section, mediaId) => {
      if (!mediaId) return;
      const panels = section.querySelectorAll('[data-media-panel]');
      const thumbs = section.querySelectorAll('[data-media-thumb]');
      let matchFound = false;

      panels.forEach((panel) => {
        const isMatch = panel.dataset.mediaPanel === String(mediaId);
        panel.hidden = !isMatch;
        if (isMatch) matchFound = true;
      });

      if (!matchFound) return;

      thumbs.forEach((thumb) => {
        thumb.setAttribute('aria-pressed', thumb.dataset.mediaThumb === String(mediaId) ? 'true' : 'false');
      });
    };

    const updateSlowFeederVariant = (section) => {
      const mapElement = section.querySelector('[data-variant-map]');
      const sizeSelect = section.querySelector('[data-variant-size]');
      const styleSelect = section.querySelector('[data-variant-style]');
      const colorSelect = section.querySelector('[data-variant-color]');
      if (!mapElement || !sizeSelect || !styleSelect || !colorSelect) return;

      const variants = JSON.parse(mapElement.textContent);
      const variant = variants.find((item) => (
        item.size === sizeSelect.value &&
        item.style === styleSelect.value &&
        item.color === colorSelect.value
      ));

      const idInput = section.querySelector('[data-variant-id]');
      const price = section.querySelector('[data-product-price]');
      const button = section.querySelector('[data-add-to-cart]');
      const summary = section.querySelector('[data-variant-summary]');

      if (!variant) {
        if (button) button.disabled = true;
        return;
      }

      if (idInput) idInput.value = variant.id;
      if (price) price.textContent = variant.price;
      if (button) {
        button.disabled = !variant.available;
        button.textContent = variant.available
          ? section.dataset.addLabel
          : section.dataset.soldLabel;
      }
      if (summary) {
        const styleLabel = styleSelect.options[styleSelect.selectedIndex].text;
        const template = section.dataset.selectionTemplate;
        summary.textContent = template
          .replace('__SIZE__', sizeSelect.options[sizeSelect.selectedIndex].text)
          .replace('__STYLE__', styleLabel)
          .replace('__COLOR__', colorSelect.options[colorSelect.selectedIndex].text);
      }

      if (variant.mediaId) showMedia(section, variant.mediaId);

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    };

    document.addEventListener('click', (event) => {
      const thumbnail = event.target.closest('[data-media-thumb]');
      if (thumbnail) {
        showMedia(findSection(thumbnail), thumbnail.dataset.mediaThumb);
        return;
      }

      const toggle = event.target.closest('[data-gallery-toggle]');
      if (!toggle) return;
      const section = findSection(toggle);
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      section.querySelectorAll('[data-extra-thumbnail]').forEach((thumb) => {
        thumb.hidden = expanded;
      });
      toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      toggle.textContent = expanded ? toggle.dataset.showLabel : toggle.dataset.hideLabel;
    });

    document.addEventListener('change', (event) => {
      const section = findSection(event.target);
      if (!section) return;

      if (event.target.matches('[data-variant-size], [data-variant-style], [data-variant-color]')) {
        updateSlowFeederVariant(section);
        return;
      }

      const select = event.target.closest('[data-native-variant]');
      if (!select) return;
      const option = select.options[select.selectedIndex];
      const price = section.querySelector('[data-product-price]');
      if (price && option.dataset.price) price.textContent = option.dataset.price;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }
  const applyBupbaProductType = (root) => {
    const selector = root.querySelector('[data-bupba-type-selector]');
    if (!selector) return;

    const selectedType = selector.value;
    const cards = root.querySelectorAll('[data-bupba-product-type]');
    let visibleCount = 0;

    for (const card of cards) {
      const isVisible = selectedType === 'all' || card.dataset.bupbaProductType === selectedType;
      card.hidden = !isVisible;
      if (isVisible) visibleCount += 1;
    }

    const status = root.querySelector('[data-bupba-type-count]');
    if (status) {
      const label = visibleCount === 1 ? status.dataset.oneProduct : status.dataset.manyProducts;
      const nextStatus = `${visibleCount} ${label}`;
      if (status.textContent !== nextStatus) status.textContent = nextStatus;
    }
  };

  const initializeBupbaProductType = (root) => {
    const selector = root.querySelector('[data-bupba-type-selector]');
    if (!selector) return;

    if (!selector.dataset.bupbaBound) {
      selector.addEventListener('change', () => applyBupbaProductType(root));
      selector.dataset.bupbaBound = 'true';
    }

    applyBupbaProductType(root);
  };

  const initializeBupbaCollections = () => {
    document.querySelectorAll('[data-bupba-type-collection]').forEach(initializeBupbaProductType);
  };

  document.addEventListener('DOMContentLoaded', initializeBupbaCollections, { once: true });
  document.addEventListener('shopify:section:load', initializeBupbaCollections);

  const bupbaCollectionObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue;

        const containsCollectionContent =
          node.matches('[data-bupba-type-collection], [data-bupba-type-selector], [data-bupba-product-type]') ||
          node.querySelector('[data-bupba-type-collection], [data-bupba-type-selector], [data-bupba-product-type]');

        if (containsCollectionContent) {
          initializeBupbaCollections();
          return;
        }
      }
    }
  });
  bupbaCollectionObserver.observe(document.documentElement, { childList: true, subtree: true });


  } catch(e) { console.error(e); }
})();
})();
